
<div class="row mb-2">
  <div class="col-12">
    <app-form-entry  [showAddTaskButton]="false"></app-form-entry>
  </div>
</div>
<div class="row mb-2">
  <div class="col-12">
    <div id="calendar">
      <full-calendar #calendar [options]="calendarOptions"></full-calendar>
    </div>
  </div>
</div>